const prepareAttributesMap = (attributesMap: Record<string, string>) =>
  Object.keys(attributesMap).reduce(
    (a, b) => ({ ...a, [`{{${b.toLowerCase()}}}`]: attributesMap[b] }),
    {},
  );

export const isValidHTML = (text: string): boolean =>
  /<\/?[a-z][\s\S]*>/i.test(text);

export const nl2br = (
  text: string,
  isXhtml = true,
  doNotTrim = false,
): string => {
  const breakTag = isXhtml ? '<br />' : '<br>';
  const trimmedText = doNotTrim ? text : text.trim();
  return trimmedText.replace(/\r\n|\n\r|\r|\n/g, breakTag);
};

export const br2nl = (text: string): string => {
  if (!text) return text;
  const regex = /<br\s*(?:\s*\/)?>/gi;
  return text?.trim()?.replace(regex, '\n');
};

export const getMergeTagsMappingWithValues = (
  mergeTags = [],
  attributes,
): {
  mergeTagsMappingForRegex: Record<string, string>;
  mergeTagsMappingWithValues: Record<string, string>;
} => {
  const mergeTagsMappingForRegex = {};

  mergeTags.forEach((mergeTag) => {
    const attribute = attributes.find((obj) => obj.fieldRef.id === mergeTag.id);
    const fallbackText = attribute ? attribute.attributeValue : '';

    mergeTagsMappingForRegex[mergeTag.label] = isValidHTML(fallbackText)
      ? fallbackText
      : nl2br(fallbackText);
  });

  return {
    mergeTagsMappingForRegex,
    mergeTagsMappingWithValues: prepareAttributesMap(mergeTagsMappingForRegex),
  };
};
